import { Injectable } from '@angular/core';
import { TemplateRenderer, MarkdownParser } from '@libs/libraries/shared';


@Injectable()
export class LegalTextParser {

	constructor(
		private templateRenderer: TemplateRenderer,
		private markdownParser	: MarkdownParser
	) {}

	parseDocument(markdown: string): string {
		return this.markdownParser.parse(markdown);
	}

	parse<T extends object>(templateParams: ILegalParseTemplateParams<T>): string {

		//0 - parse template
		// > Note: Template renderer adds new line for the entries in the loop
		// > To avoid this addition of unwanted lines we replace the sequence of
		// > line and delimiters with just the delimiter
		templateParams.template = templateParams.template.replace(/\n<!--[^=]/g, '<!--');
		const templateParsed: string = this.templateRenderer.parseMarkdown(templateParams);

		//1 - remove all tabs
		const templateWithoutTabs: string = templateParsed.replace(/\t+/g, '');

		//2 - parse marked down
		const mdParsed: string = this.markdownParser.parse(templateWithoutTabs);

		//3 - return parsed string
		return mdParsed;
	}
}


//** Interfaces --------------------------------- */
interface ILegalParseTemplateParams<T extends object> {
	template: string;
	context	: T;
}
